var EmergencyViewModal = (function (base) {
  __extends(EmergencyViewModal, base);

  function EmergencyViewModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };

  EmergencyViewModal.prototype.activate = function (emergencyId, isAdmin, deleteFunc, showOnMapFunc) {
    const self = this;
    const url = `api/emergencies/${emergencyId}`;

    this.loadContent(url)
      .then($modal => {

        $modal

          //Checkbox сценариев действия
          .on('change', '.control-label--custom', function () {
            var control = $(this);
            if (isAdmin || confirm('После выбора этого действия, отменить его будет невозможно. Вы действительно хотите выбрать это действие?')) {

              _sendScenario.call(self, emergencyId, control.data('scenario-id'), control.prop('checked'))
                .then(() => {
                  if (!isAdmin) {
                    control.prop('disabled', true);
                  }
                })
                .catch(() => {
                  //Восстанавливаем предыдущее состояние checkbox
                  control.prop('checked', !control.prop('checked'));
                });
            } else {
              control.prop('checked', false);
            }
          })

          //Кнопка `Удалить комментарий`
          .on('click', '.note-delete', function () {
            const noteId = $(this).data('id');
            if (confirm('Вы действительно хотите удалить этот комментарий?')) {
              _deleteNote.call(self, emergencyId, noteId)
                .then(() => {
                  //TODO: необходимо реализовать механизм обновления списка комментариев
                  self.reloadContent(url);
                });
            }
          })

          //Кнопка `Добавить комментарий`
          .on('click', '.note-add', function () {
            const noteText = $('#Note', $modal).val();

            _addNote.call(self, emergencyId, noteText)
              .then(() => {
                //TODO: необходимо реализовать механизм обновления списка комментариев
                self.reloadContent(url);
              });
          })

          //Кнопка `Редактировать`
          .on('click', '[js=edit]', function () {
            ModalConductor.activate(EmergencyEditModal, emergencyId)
              .on('closed', (modalResult) => {
                if (modalResult.ok) {
                  self.reloadContent(url);
                }
              });
          })

          //Кнопка `Показать на карте`
          .on('click', '[js=show-on-map]', function () {
            showOnMapFunc(emergencyId);
          })

          //Кнопка `Удалить`
          .on('click', '[js=delete]', function () {
            if (confirm(`Вы действительно хотите удалить эту чрезвычайную ситуацию?`)) {
              deleteFunc(emergencyId);
            }
          });
      });
  };


  function _sendScenario(emergencyId, scenarioId, isChecked) {
    return this.apiClient.post(`api/emergencies/${emergencyId}/scenarios/${scenarioId}`, { isChecked: isChecked });
  };

  function _deleteNote(emergensyId, noteId) {
    return this.apiClient.delete(`api/emergencies/${emergensyId}/notes`, { noteId: noteId });
  }

  function _addNote(emergensyId, text) {
    return this.apiClient.put(`api/emergencies/${emergensyId}/notes`, { text: text });
  };


  return EmergencyViewModal;
}(BaseModal));
